import {Button} from '@material-ui/core';
import CoreRouteConstants from 'Core/CoreRouteConstants';
import React from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';

type UsernameRecoveryEmailSentProps = RouteComponentProps;

const UsernameRecoveryEmailSent = (props: UsernameRecoveryEmailSentProps) => {
  return (
    <div className="username-recovery__form">
      <h1>Email Sent</h1>
      <p className="username-recovery__description">
        An email has been sent containing your username. Please check your email.
      </p>
      <Button
        className="username-recovery__return-to-login-button"
        fullWidth
        onClick={() => props.history.push(CoreRouteConstants.LOGIN)}
        variant="contained"
        color="primary"
      >
        Return to Login
      </Button>
    </div>
  );
};

export default withRouter(UsernameRecoveryEmailSent);
